import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoins, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';
import Select from "react-select";
import { useNavigate, useLocation } from 'react-router-dom'
import TradingViewWidget from "../components/TradingViewWidget";
import { formatCurrency } from '../utils/currencyUtils';

function StakeDetails() {
  const { user } = useUser();
  const [loading, setLoading] = useState(true);
  const { state } = useLocation();
  const [stake_id, setStake_id] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    const stake_id = state?.stake_id;
    if (!stake_id) {
      navigate('/stake', { replace: true });
    } else {
      setLoading(false);
      setStake_id(stake_id);
    }
  }, [state, navigate]);
  const [crypto, setCrypto] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const darkThemeStyles = {
    control: (styles) => ({
        ...styles,
        backgroundColor: "#151719",
        border: "none",
        color: "#fff",
    }),
    menu: (styles) => ({
        ...styles,
        backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
        color: "#fff",
    }),
    singleValue: (styles) => ({
        ...styles,
        color: "#fff",
    }),
  };
  const durationoptions = [
    { value: "1", label: "1 day" },
    { value: "2", label: "2 days" },
    { value: "3", label: "3 days" },
    { value: "4", label: "4 days" },
    { value: "5", label: "5 days" },
    { value: "6", label: "6 days" },
  ];
  const [allstaking, setAllstaking] = useState([]);
  const [stake, setStake] = useState([]);
  const [usdbal, setUsdbal] = useState(0);
  const [amount, setAmount] = useState();
  const [duration, setDuration] = useState("1 day");
  const [error, setError] = useState(false);
  const [errorValue, setErrorValue] = useState();
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchStake: true, stake_id : stake_id })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setStake(data.stake);
      }
    })
    .catch(err => {
        console.error('Error fetching stakes!')
    })
  }, [user]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchmyStake: true, stake_id : stake_id })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setAllstaking(data.mystake);
      }
    })
    .catch(err => {
        console.error('Error fetching stakes!')
    })
  }, [stake_id]);

  useEffect(() => {
    fetch(`/coin_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    var coinList = data.data;
    const updatedData = coinList.map((coin, index) => ({
        id: index + 1,
        symbol: coin.symbol,
        value: coin.id,
        label: (
          <>
            <img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" style={{ marginRight: 5 }} />
            {coin.symbol}
          </>
        ),
        logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
    }));
    setCrypto(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchCoinBalance: true, coin_id: stake.coin_id })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
            setUsdbal(data.balance);
        }
    })
    .catch(err => {
        console.log(err);
        console.error('Error fetching coin balance!')
    })
  }, [stake]);
  function validateAmount (value){
    setAmount(value);
    if(parseFloat(usdbal) === 0){
        setError(true);
        setErrorValue(`Your current balance is 0.00 ${stake.symbol}. Kindly choose a lower amount or deposit into your account.`);
    }else if(parseFloat(value) < parseFloat(stake.minimum_amt)){
        setError(true);
        setErrorValue(`The minimum allowed amount is ${stake.minimum_amt} ${stake.symbol}. Please enter a higher amount.`);
    }else if(parseFloat(value) > parseFloat(stake.maximum_amt)){
        setError(true);
        setErrorValue(`The maximum allowed amount is ${stake.maximum_amt} ${stake.symbol}. Please enter a lower amount.`);
    }else{
        setError(false);
        setErrorValue("");
    }
  }
  const ValidateStake = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/stake.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
        "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_stake: true, amount: amount, price: stake.price, stake_id : stake_id, coin_id : stake.coin_id, roi : stake.roi, duration : duration })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
            window.location.href = "stake";
            }, 2000);
        }else{
        toast.error(data.message);
        }
        setLoading(false);
    })
    .catch(err => {
        console.error(err)
        setLoading(false);
    })
  }

  if (loading && !stake) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Stake" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Stake" icon={<FontAwesomeIcon icon={faCoins} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row mt-2 mb-5">
              <div className="col-lg-4">
                <div className="mycard p-3" style={{border:'1px solid #ffffff0d'}}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <p className="mb-0 fw-bold" style={{fontSize:'20px'}}>Stake Token</p>
                            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Current staking method</p>
                        </div>
                        <div className="p-2 rounded-pill d-flex align-items-center" style={{backgroundColor:'#ffffff1c'}}>
                            <img src={stake.logo} alt={stake.name} style={{width:'30px'}} />
                            <p className="mb-0 fw-semibold ms-1">{stake.name}</p>
                        </div>
                    </div>
                    <div className="mt-4 d-flex align-items-center justify-content-between">
                        <div>
                            <p className="mb-0 fe-semibold">Stake Amount</p>
                            <input 
                                type="text"
                                placeholder={stake.minimum_amt}
                                className="inputNone inputLarge"
                                value={amount}
                                onChange={(e) => validateAmount(e.target.value)}
                            />
                            {error && (
                                <p className="mb-0 fw-semibold text-danger mt-1" style={{fontSize: '12px'}}>{errorValue}</p>
                            )}
                            <div className="d-flex align-items-center mt-0" style={{gap:'5px'}}>
                                <p className="mb-0 text-secondary" style={{fontSize: '13px'}}>Avl. Bal:</p>
                                <p className="mb-0 text-secondary" style={{fontSize: '13px'}}>{usdbal} {stake.symbol}</p>
                            </div>
                        </div>
                        <div className="p-2 rounded-pill d-flex align-items-center" style={{opacity:'0.5',backgroundColor:'#ffffff1c'}}>
                            <img src={stake.logo} alt={stake.name} style={{width:'30px'}} />
                            <p className="mb-0 fw-semibold ms-1">{stake.name}</p>
                        </div>
                    </div>
                    <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Duration:</label>
                    <div className="mycard w-100 p-2 rounded-pill noSelect">
                        <Select 
                            options={durationoptions} 
                            value={durationoptions.find((opt) => opt.value === duration)}
                            onChange={(e) => setDuration(e.value)}
                            styles={darkThemeStyles}
                            className="w-full"
                        />
                    </div>
                    <label className="fw-semibold mt-2 mb-1">ROI:</label>
                    <div className="mycard w-100 p-1 px-3 rounded-pill noSelect">
                        <div className="d-flex align-items-between justify-content-between">
                        <input 
                            type="text"
                            className="inputNone inputLarge "
                            readOnly
                            value={`${stake.roi}%`}
                        />
                        <div className="fw-bold text-white d-flex align-items-center" style={{borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>%
                        </div>
                        </div>
                    </div>
                    <div className={`myBtn rounded-pill text-center mt-4 ${!amount?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px',background:'linear-gradient(172deg, #ff6b35, #000000)',border:'2px solid #ff6b35'}} onClick={amount ? ValidateStake : null}>
                        {loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:(
                            <>
                                <img src={stake.logo} alt={stake.name} style={{width:'25px'}} />
                                <span className="ms-1 fw-semibold">Stake</span>
                            </>
                        )}
                    </div>
                    <div className="mycard p-3 mt-4" style={{border:'1px solid #ffffff0d'}}>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <div className="w-40">
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Minimum Stake</p>
                                <p className="mb-0" style={{fontWeight:'900',fontSize:'20px'}}>{stake.minimum_amt} {stake.symbol}</p>
                            </div>
                            <div className="w-40">
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Maximum Stake</p>
                                <p className="mb-0" style={{fontWeight:'900',fontSize:'20px'}}>{stake.maximum_amt} {stake.symbol}</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="w-40">
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Stake Cycle</p>
                                <p className="mb-0" style={{fontWeight:'900',fontSize:'20px'}}>{stake.cycle}</p>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="mycard p-3" style={{border:'1px solid #ffffff0d'}}>
                    <TradingViewWidget height="500" symbol={stake.symbol} type='cypto' />
                </div>
                <div className="mycard p-3 mt-2" style={{border:'1px solid #ffffff0d'}}>
                    <div className="table-responsive scrollDown" style={{maxHeight: '60vh'}}>
                        <table className="table table-hover table-striped table-hover table-borderless table-dark align-middle">
                            <thead>
                                <tr className="fs-7">
                                <th>Ref</th>
                                <th>Amount</th>
                                <th>Duration</th>
                                <th className="text-nowrap">Total (USD)</th>
                                <th>ROI</th>
                                <th className="text-nowrap">Stake Date</th>
                                <th>Status</th>
                                </tr>
                            </thead>
                            <tbody style={{fontSize: '14px'}}>
                            {allstaking.length > 0 ? (
                                allstaking.map((staking, key) => (
                                    <tr key={key}>
                                        <td>{staking.stake_id}</td>
                                        <td>{formatCurrency(staking.amount)}</td>
                                        <td>{staking.duration} {staking.duration == 1?'Day':'Days'}</td>
                                        <td className="fw-semibold">{formatCurrency(staking.roi_usd)}</td>
                                        <td className="text-nowrap fw-semibold text-success">{staking.roi} {staking.symbol}</td>
                                        <td className="text-nowrap">{staking.date}</td>
                                        <td className="py-3"><span className={`${staking.status == 1?'status-success':'status-danger'}`}>{staking.status == 1?'Open':'Closed'}</span></td>
                                    </tr> 
                                ))
                            ) : (
                                <tr>
                                    <td className="py-5 text-center" colSpan={7}>You have not staked any asset yet.</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default StakeDetails